import { useGetFormValidationError } from "@tm/localization"
import { useMemo } from "react"
import { z } from "zod"

const MIN_POSSIBLE_NUMBER = 0.01
const MAX_POSSIBLE_NUMBER = 99999.99

export function useSchema(hasFixedPrice: boolean) {
    const getError = useGetFormValidationError()
    return useMemo(() => {
        const rangeError = getError("VALUE_RANGE", MIN_POSSIBLE_NUMBER, MAX_POSSIBLE_NUMBER)
        return z.object({
            workId: z.string().optional(),
            description: z
                .string({ required_error: getError("REQUIRED") })
                .trim()
                .min(1, getError("REQUIRED")),
            category: z.number({ required_error: getError("REQUIRED") }).gt(0, getError("REQUIRED")),
            vatType: z.number({ required_error: getError("REQUIRED") }).gt(0, getError("REQUIRED")),
            ...(!hasFixedPrice && {
                workTime: z
                    .number({ required_error: getError("REQUIRED") })
                    .min(MIN_POSSIBLE_NUMBER, rangeError)
                    .max(MAX_POSSIBLE_NUMBER, rangeError),
                customHourlyRate: z
                    .number({ required_error: getError("REQUIRED") })
                    .min(MIN_POSSIBLE_NUMBER, rangeError)
                    .max(MAX_POSSIBLE_NUMBER, rangeError),
            }),
            ...(hasFixedPrice && {
                workTime: z.number().min(MIN_POSSIBLE_NUMBER, rangeError).max(MAX_POSSIBLE_NUMBER, rangeError).optional(),
                fixedPriceValue: z
                    .number({ required_error: getError("REQUIRED") })
                    .min(MIN_POSSIBLE_NUMBER, rangeError)
                    .max(MAX_POSSIBLE_NUMBER, rangeError),
            }),
        })
    }, [hasFixedPrice, getError])
}
